import form from "../../api/form";
import { perPageCount } from "@/common/constants";
import { dummyRows, StatusIcon } from "@/common/functions";
import { getFormShareUrl } from "@/common/http.header";

const getDefaultState = () => {
  return {
    items: [],
    loaded: false,
    itemLoaded: false,
    isReport: false,
    filter: {
      page: 1,
      limit: perPageCount,
      search_text: "",
      date_from: "",
      date_to: "",
      status: "",
      order_by: "",
      order: "",
      add_sort: 0,
    },
    totalItems: 0,
    total: 0,
    busyLoaderStatus: true,
    showFilter: false,
    createOrEdit: "",
    pageLoad: false,
    formName: "",
  };
};

// initial state
const state = getDefaultState();

// getters
const getters = {
  getItems: (state) => {
    if (!state.items.length && !state.loaded) {
      return dummyRows();
    }
    return state.items.map((item) => {
      var status = "";
      switch (item.status) {
        case 1:
          status = "Active";
          break;
        case 2:
          status = "Draft";
          break;
        case 3:
          status = "Duplicate";
          break;
        default:
          status = "Inactive";
      }
      let disabled = [];
      if (!item.submissionCount && state.isReport) {
        disabled.push("action");
      }
      return {
        id: item.id,
        name: { title: item.name, text: item.modifieddate },
        status: { text: status, type: StatusIcon(status) },
        type: item.type_text,
        viewCount: item.viewCount,
        disabled,
        submissionCount: {
          first: item.submissionCount,
          second: item.submission_perc + "%",
          popup: true,
        },
        cam_actions: {
          View: item.status !== 1,
          Share: item.status !== 1,
          Activate: item.status !== 4,
          Deactivate: item.status !== 1,
          Delete: [1, 4].includes(item.status),
        },
        form_url:
          getFormShareUrl() +
          ([1, 2].includes(item.type) ? "form" : "popup") +
          "?id=" +
          item.form_url +
          "&preview",
      };
    });
  },

  getCreateOrEdit: (state) => {
    return state.createOrEdit ? state.createOrEdit : "Edit";
  },
};

// actions
const actions = {
  fetchItems({ commit, state }, params) {
    var filter = state.filter;
    if (
      !state.loaded ||
      filter.page !== params.page ||
      filter.limit !== params.limit ||
      filter.search_text !== params.search_text ||
      filter.date_from !== params.date_from ||
      filter.date_to !== params.date_to ||
      filter.status !== params.status ||
      filter.order_by !== params.order_by ||
      filter.order !== params.order
    ) {
      commit("setFilter", { ...params });
      if (!params.status) {
        delete params.status;
      }
      return new Promise(function (resolve) {
        form.fetchItems(params, (data) => {
          commit("setItems", { items: data.items });
          commit("setTotalItems", data.total);
          commit("setLoaded", true);
          commit("setBusyLoaderStatus", true);
          resolve(data);
        });
      });
    }
  },

  clearSingleItem({ commit }) {
    commit("setItemLoaded", false);
  },

  refreshItems({ commit, state, dispatch }) {
    commit("setLoaded", false);
    dispatch("fetchItems", state.filter);
  },

  resetState({ commit }) {
    commit("resetState");
  },
  deleteForm({ commit, state, dispatch }, params) {
    return form.deleteForm(params.id).then(function () {
      dispatch("refreshItems");
    });
  },
  activateForm({ dispatch }, { id }) {
    return form.activate(id).then(function () {
      dispatch("refreshItems");
    });
  },
  deactivateForm({ dispatch }, { id }) {
    return form.deactivate(id).then(function () {
      dispatch("refreshItems");
    });
  },
  cloneForm({ commit, state, dispatch }, params) {
    return form.cloneForm(params.id).then(function () {
      dispatch("refreshItems");
    });
  },
};

// mutations
const mutations = {
  setItems(state, { items }) {
    state.items = items;
  },

  setFilter(state, data) {
    state.filter = data;
  },

  setTotalItems(state, total) {
    state.totalItems = total;
  },

  setLoaded(state, loaded) {
    state.loaded = loaded;
  },

  setItemLoaded(state, loaded) {
    state.itemLoaded = loaded;
  },

  setIsReport(state, loaded) {
    state.isReport = loaded;
  },

  setCreateOrEdit(state, createOrEdit) {
    state.createOrEdit = createOrEdit;
  },
  setTotal(state, total) {
    state.total = total;
  },
  setBusyLoaderStatus(state, status) {
    state.busyLoaderStatus = status;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
  setShowFilter(state, status) {
    state.showFilter = status;
  },
  setPageLoad(state, data) {
    state.pageLoad = data;
  },
  setFormName(state, data) {
    state.formName = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
